const state = {
  addressObj: ''
}
const getters = {
  getConfirmOrderAddress (state) {
    return state.addressObj
  }
}
const actions = {
  fetchParams ({state, commit}, item) {
    commit('setParams', item)
  }
}
const mutations = {
  setConfirmOrderAddress (state, item) {
    state.addressObj = item
  }
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
